
/* injects from baggage-loader */

'use strict';

import DialoQuizMacacoComponent from './quiz-macaco.component';

const dialogQuizMacacoModule = angular.module('dialog-quiz-macaco-module', []);

dialogQuizMacacoModule
    .component('dialogQuizMacaco', new DialoQuizMacacoComponent());

export default dialogQuizMacacoModule;



// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-macaco/quiz-macaco.module.js